import React, { useEffect, useState } from 'react';
import DeleteButton from '../../../../components/UI/Buttons/DeleteButton';
import classes from './Closed.module.css';
import ClosedModal from '../../Modals/Closed/ClosedModal';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';

import EditButton from '../../../../components/UI/Buttons/EditButton';
import { useTranslation } from '../../../../hooks/useTranslations';

import 'moment/locale/es';

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
  setOpeningHoursModal: (value: number) => void;
};

const Closed: React.FC<Props> = ({ isModalOpen, onModalClose, setOpeningHoursModal }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  const [selectedItem, setSelectedItem] = useState<Date | undefined>();

  const lang = localStorage.getItem('lang') || 'en';

  const handleDelete = async (item: any) => {
    const found = calendarAndSlots?.excludes?.find((e: any) => e == item);
    const filteredData = [...calendarAndSlots?.excludes].filter((item) => item !== found);
    let dataToPost = [
      {
        ...calendarData[0],
        excludes: filteredData,
      },
    ];
    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
  };
  const onEditClick = (item: any) => {
    setOpeningHoursModal(2);
    setSelectedItem(item);
  };
  useEffect(() => {
    if (!isModalOpen) {
      setSelectedItem(undefined);
    }
  }, [isModalOpen]);
  return (
    <>
      <div className={classes.container}>
        <div className={classes.mainContainer}>
          <text className={classes.headerText}>{translations('date')}</text>
        </div>
        <div>
          {calendarAndSlots?.excludes?.map((item: any, index: any) => (
            <div key={index} className={classes.flatlistContainer}>
              <div className={classes.textContainer}>
                <text className={classes.text}>{moment(item).locale(lang).format('DD.MM.YYYY ; dddd')}</text>
              </div>
              <div className={classes.button}>
                <EditButton onClick={() => onEditClick(item)} />
              </div>
              <div className={classes.button}>
                <DeleteButton onClick={() => handleDelete(item)} />
              </div>
            </div>
          ))}
        </div>
      </div>
      <ClosedModal isOpen={isModalOpen} item={selectedItem} onClose={onModalClose} />
    </>
  );
};

export default Closed;
